import { useQuery } from "@tanstack/react-query";

import {
  byttUtIHtml,
  erVedleggUrl,
  SIGNERT_LEVETID_SEKUNDER,
  signerStier,
  stiFraUrl,
  stierIHtml,
} from "./vedleggUrl";

// Signerte lenker gjenbrukes til de nesten er utløpt. react-query deduper
// samtidig, så to notater med samme bilde gir ett kall, ikke to.
const FERSK_MS = (SIGNERT_LEVETID_SEKUNDER - 300) * 1000;

/**
 * HTML der pekerne inn i vedleggsbøtta er byttet ut med signerte lenker.
 *
 * INNHOLD UTEN VEDLEGG GÅR RETT GJENNOM, synkront og uten et eneste kall.
 * Det er det vanlige tilfellet — de aller fleste notater har ingen bilder — og
 * det ville vært galt å la dem blinke gjennom en lastetilstand for noe de ikke
 * har.
 */
export const useSignertHtml = (html?: string | null): string | null => {
  const stier = stierIHtml(html);
  const noklen = stier.slice().sort().join("|");

  const { data: kart } = useQuery({
    queryKey: ["signerte-vedlegg", noklen],
    queryFn: () => signerStier(stier),
    enabled: stier.length > 0,
    staleTime: FERSK_MS,
    gcTime: FERSK_MS,
  });

  if (!html) return html ?? null;
  if (stier.length === 0) return html;
  // Mens signeringen pågår holder vi bildene tilbake i stedet for å vise dem
  // brutt et halvt sekund. Teksten kommer med det samme kartet er der.
  if (!kart) return null;
  return byttUtIHtml(html, kart);
};

/**
 * Én signert lenke. Peker URL-en et annet sted enn vedleggsbøtta — en ekstern
 * adresse, en `blob:` fra en fil som nettopp ble valgt — sendes den uendret
 * tilbake.
 */
export const useSignertUrl = (url?: string | null): string | null => {
  const sti = erVedleggUrl(url) ? stiFraUrl(url) : null;

  const { data: kart } = useQuery({
    queryKey: ["signerte-vedlegg", sti ?? ""],
    queryFn: () => signerStier([sti as string]),
    enabled: sti != null,
    staleTime: FERSK_MS,
    gcTime: FERSK_MS,
  });

  if (!url) return url ?? null;
  if (!sti) return url;
  return kart?.get(sti) ?? null;
};
